export const PROJECT_ID_NAVIGATION = {
  INFORMATION: 'information',
  TECHNICAL_STACK: 'technical-stack',
  MEMBERS: 'members',
  ACTIVITIES: 'activities',
};

export const EMPLOYEE_ID_NAVIGATION = {
  INFORMATION: 'employee-info',
  SKILLS: 'employee-skills',
  PROJECTS: 'employee-projects',
  RELATIONSHIPS: 'employee-relationships',
  ACTIVITIES: 'employee-activities',
};

export const PROJECT_TOOLTIP_CONTENT = {
  INFORMATION: 'Project Information',
  TECHNICAL_STACK: 'Technical Stack',
  MEMBERS: 'Project Members',
  ACTIVITIES: 'Project Activities',
};

export const EMPLOYEE_TOOLTIP_CONTENT = {
  INFORMATION: 'Information',
  SKILLS: 'Skills',
  PROJECTS: 'Projects',
  RELATIONSHIPS: 'Relationships',
  ACTIVITIES: 'Activities',
};

export const HREF_TO_LABEL_TOOLTIP = {
  [`#${PROJECT_ID_NAVIGATION.INFORMATION}`]:
    PROJECT_TOOLTIP_CONTENT.INFORMATION,
  [`#${PROJECT_ID_NAVIGATION.TECHNICAL_STACK}`]:
    PROJECT_TOOLTIP_CONTENT.TECHNICAL_STACK,
  [`#${PROJECT_ID_NAVIGATION.MEMBERS}`]: PROJECT_TOOLTIP_CONTENT.MEMBERS,
  [`#${PROJECT_ID_NAVIGATION.ACTIVITIES}`]: PROJECT_TOOLTIP_CONTENT.ACTIVITIES,

  // Employee
  [`#${EMPLOYEE_ID_NAVIGATION.INFORMATION}`]:
    EMPLOYEE_TOOLTIP_CONTENT.INFORMATION,
  [`#${EMPLOYEE_ID_NAVIGATION.PROJECTS}`]: EMPLOYEE_TOOLTIP_CONTENT.PROJECTS,
  [`#${EMPLOYEE_ID_NAVIGATION.SKILLS}`]: EMPLOYEE_TOOLTIP_CONTENT.SKILLS,
  [`#${EMPLOYEE_ID_NAVIGATION.RELATIONSHIPS}`]:
    EMPLOYEE_TOOLTIP_CONTENT.RELATIONSHIPS,
  [`#${EMPLOYEE_ID_NAVIGATION.ACTIVITIES}`]:
    EMPLOYEE_TOOLTIP_CONTENT.ACTIVITIES,
};
